import axios from 'axios';

const getCoordinates = async (address) => {
  try {
    const response = await axios.get('https://nominatim.openstreetmap.org/search', {
      params: {
        q: address,
        format: 'json',
      },
    });

    
    if (response.data.length > 0) {
      const location = response.data[0];
      return { lat: parseFloat(location.lat), lng: parseFloat(location.lon) };
    } else {
      throw new Error('Nessuna coordinata trovata per l\'indirizzo fornito.');
    }
  } catch (error) {

    console.error('Errore durante il recupero delle coordinate:', error);
    return { lat: "", lng:"" };
  }
};

export default getCoordinates;
